import styled from '@emotion/styled';

interface GapProps {
  t?: number; // Top margin
  l?: number; // Left margin
  r?: number; // Right margin
  b?: number; // Bottom margin
}

const Gap = styled.div<GapProps>`
  margin-top: ${({ t }) => (t ? `${t}px` : '0')};
  margin-left: ${({ l }) => (l ? `${l}px` : '0')};
  margin-right: ${({ r }) => (r ? `${r}px` : '0')};
  margin-bottom: ${({ b }) => (b ? `${b}px` : '0')};
`;

export default Gap;
